export const APP_LAYOUT_SCREEN_CLASSNAME = 'AppLayout-screen';
